export { default } from './StudentsPerformance'
export type { StudentsPerformanceProps, StudentsPerformanceVariant } from './StudentsPerformance'
